import { render } from "./BackgroundComponent.vue?vue&type=template&id=ce31dc06&scoped=true"
import script from "./BackgroundComponent.vue?vue&type=script&lang=js"
export * from "./BackgroundComponent.vue?vue&type=script&lang=js"

import "./BackgroundComponent.vue?vue&type=style&index=0&id=ce31dc06&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.30_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce31dc06"]])

export default __exports__